// Products.js

import React from 'react';
import { Link } from 'react-router-dom';
import productImage1 from '../../img/SM1/PlayScreen.png';
import productImage2 from '../../img/SM2/World2.png';
import productImage3 from "../../img/Triangle/WinCondition.png"
import GooglePlayStoreLogo from '../../img/logo/GooglePlayStoreLogo1.png';

const Products = () => {
  return (
    <div className="container mt-4">
       <h2 className="text-center mb-4">Products list</h2>
      <div className="row">
        <div className="col-md-4 mb-4">
          <div className="card">
         
            <div className="card-body">
              {/* <h5 className="card-title">Space Mathster</h5> */}
              <Link to="/product-details/spacemathster" h5 className="card-title">Space Mathster</Link>
              <p className="card-text">A fun and engaging multiplication game designed to help young children learn and practice multiplication in an enjoyable environment.</p>
              <a href="https://play.google.com/store/apps/details?id=com.FourCyGameStudio.SpaceMathster" target="_blank" rel="noopener noreferrer">
              <img src={GooglePlayStoreLogo} className="card-img-top" alt="Link to Google Play store" /></a>
              <img src={productImage1} className="card-img-top" alt="Space Mathster play screen1" />
             
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card">
        
            <div className="card-body">
              {/* <h5 className="card-title">Space Mathster 2</h5> */}
              <Link to="/product-details/spacemathster2" h5 className="card-title">Space Mathster 2</Link>
              <p className="card-text">An improved multiplication game for young children, featuring enhanced gameplay and exciting boss fights to make learning multiplication even more fun.</p>
              <a href="https://play.google.com/store/apps/details?id=com.FourCYGameStudio.SpaceMath_Two_v2" target="_blank" rel="noopener noreferrer">
              <img src={GooglePlayStoreLogo} className="card-img-top" alt="Link to Google Play store"   /></a>
              <img src={productImage2} className="card-img-top" alt="Space Mathster2 play screen1" />
             
            </div>
          </div>
        </div>
        <div className="col-md-4 mb-4">
          <div className="card">
            <div className="card-body">
              {/* <h5 className="card-title">Triangle Game</h5> */}
              <Link to="/product-details/triangleGame" h5 className="card-title">Nimbly</Link>
              <p className="card-text">A captivating and strategic stick game for all ages that tests your tactical skills and challenges your strategic planning</p>
              <a href="https://play.google.com/store/apps/details?id=com.FourcyGameStudio.Nimbly" target="_blank" rel="noopener noreferrer">
              <img src={GooglePlayStoreLogo} className="card-img-top" alt="Link to Google Play store"   /></a>
              <img src={productImage3} className="card-img-top" alt="Nimbly play screen" />
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Products;
